import { render } from "./DinoAngry.vue?vue&type=template&id=75afffc6"
const script = {}
script.render = render

export default script